import httpService from '@Utils/httpService';

const baseUrl = 'api/forge/projects';

export default {
  // Get all projects (flat list)
  getAll() {
    return httpService.get({
      url: baseUrl,
    });
  },

  // Get projects by asset ID (flat list)
  getByAsset(assetId, config = {}) {
    return httpService.get({
      url: `${baseUrl}/asset/${assetId}`,
      ...config,
    });
  },

  // Get tree structure by asset ID (nested folders with parentId/children)
  getTree(assetId) {
    return httpService.get({
      url: `${baseUrl}/tree/${assetId}`,
    });
  },

  // Create new project or folder (parentId determines nesting)
  create(projectData) {
    return httpService.post({
      url: baseUrl,
      data: projectData,
    });
  },

  // Update existing project/folder
  update(id, projectData) {
    return httpService.put({
      url: `${baseUrl}/${id}`,
      data: projectData,
    });
  },

  // Delete project/folder (and all children)
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },

  // Clear project master scan
  clearMasterScan(projectId) {
    return httpService.delete({
      url: `${baseUrl}/clearProjectMasterScan/${projectId}`,
    });
  },
}
